import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {},

  input: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem 0 1rem 0',
    height: '40px',
    paddingBottom: '0.25rem',

    '& input': {
      flex: '1',
      border: 'none',
      outline: 'none',
      fontSize: theme.size.sm
    }
  },

  multiLine: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem 0 1rem 0',
    height: '40px',
    paddingBottom: '0.25rem',
    fontSize: theme.size.sm,

    '& > :nth-child(1)': {
      alignSelf: 'baseline'
    },

    '& textarea': {
      flex: '1',
      border: 'none',
      outline: 'none',
      resize: 'none'
    }
  },

  userSearch: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem 0 1rem 0',
    height: '40px',
    paddingBottom: '0.25rem',
    flexWrap: 'wrap',

    '& input': {
      flex: '1',
      border: 'none',
      outline: 'none'
    }
  },

  endControls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    marginTop: '10px',

    [theme.breakpoints.down(769)]: {
      '& button': {
        fontSize: theme.size.base
      }
    },

    [theme.breakpoints.down(451)]: {
      justifyContent: 'space-between',
      margin: '1rem 0',
      width: '100%',

      '& button': {
        flexBasis: '48.5%'
      },

      '& > button > .MuiButton-label': {
        fontSize: theme.size.sm
      },

      '& > div': {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        marginTop: '0.5rem',
        marginLeft: '0',
        marginBottom: '2rem'
      }
    }
  },

  button: {
    marginRight: '0.5rem',
    width: 'auto',
    padding: '0 1rem',
    fontSize: theme.size.sm,

    '&:last-child': {
      marginRight: '0'
    }
  },

  chip: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #1F1F1F',
    borderRadius: '100rem',
    boxSizing: 'border-box',
    padding: '6px 12px',
    background: 'white',
    cursor: 'default',
    fontSize: theme.size.sm,
    color: '#1F1F1F',
    marginRight: 8,
    marginBottom: 5,

    '& label': {}
  },

  chipAvatar: {
    width: 24,
    height: 24,
    marginRight: 6,
    fontSize: theme.size.xs
  },

  chipAction: {
    margin: '0px 4px',
    cursor: 'pointer'
  },

  userSearchSection: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '2px solid #F1F1F1',
    paddingBottom: '0.25rem',
    margin: '0.5rem 0 1rem 0',
    minHeight: 40,

    '& > :nth-child(1)': {
      marginRight: '10px'
    },

    '& > :nth-child(2)': {
      display: 'flex',
      flexWrap: 'wrap',
      maxHeight: 150,
      overflowY: 'auto'
    },

    '& input': {
      flex: '1',
      border: 'none',
      outline: 'none'
    },

    '&:focus-within': {
      borderBottomColor: 'black'
    }
  },

  resultsContainer: {
    border: '1px solid #F0F0F0',
    borderRadius: '7px',
    boxSizing: 'border-box',
    boxShadow: '0px 20px 30px rgba(0, 0, 0, 0.16)',
    padding: '16px',
    background: 'white',

    '& > ul': {
      padding: '0'
    }
  },

  resultsTitle: {
    marginBottom: '8px',
    fontSize: theme.size.sm,
    color: '#8F8F8F',
    cursor: 'default'
  },

  results: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '208px',
    overflow: 'hidden auto',

    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: '#E5E5E5'
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 0
    }
  },

  result: {
    borderRadius: '8px',
    minHeight: '52px',
    height: '52px',
    maxHeight: '52px',
    padding: '0',
    fontSize: theme.size.base,
    color: '#3C425B',
    alignItems: 'center',
    display: 'flex',

    '&:hover': {
      background: '#F5F6F8'
    }
  },

  noResult: {
    borderRadius: '8px',
    minHeight: '52px',
    height: '52px',
    maxHeight: '52px',
    padding: '0',
    fontSize: theme.size.base,
    color: 'grey',
    cursor: 'default',
    alignItems: 'center',
    display: 'flex',
    opacity: '0.7'
  },

  deletedUser: {
    color: 'lightgrey',
    textDecoration: 'line-through'
  },

  memberInput: {
    fontSize: theme.size.sm
  }
}))

export default useStyles
